var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popupRight"},[_c('a',{attrs:{"href":_vm.popupHref}},[_c('img',{attrs:{"src":_vm.popupImg,"alt":""}})]),_vm._v(" "),_c('span',{attrs:{"id":"popupNone"}},[_c('p',[_vm._v(_vm._s(_vm.popup))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab3816e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popup/popupRight.vue
// module id = null
// module chunks = 